import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Chat } from './components/Chat';
import { Dashboard } from './pages/Dashboard';
import { Billing } from './pages/Billing';
import { Chats } from './pages/Chats';
import { ChatPage } from './pages/ChatPage';
import { Settings } from './pages/Settings';
import { HardwareHome } from './pages/HardwareHome';
import { OnshapeLogin } from './pages/auth/OnshapeLogin';
import { OnshapeCallback } from './pages/auth/OnshapeCallback';
import { AuthGuard } from './components/auth/AuthGuard';
import { Layout } from './components/Layout';
import { LoginButton } from './components/auth/LoginButton';
import { useAuth } from './hooks/useAuth';
import { useAppMode } from './hooks/useAppMode';
import { LEGACY_FEATURES_ENABLED } from './lib/features';
import { preserveQueryParams } from './lib/navigation-utils';
import './index.css';

// Redirect to root without dropping Onshape's ?documentId=&workspaceId=&elementId= context.
function RedirectHome() {
  return <Navigate to={preserveQueryParams('/')} replace />;
}

function App() {
  const { authenticated, loading } = useAuth();
  const { isIframe } = useAppMode();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/auth/login" element={<OnshapeLogin />} />
        <Route path="/auth/callback" element={<OnshapeCallback />} />

        {/* Protected routes with Layout */}
        <Route
          element={
            <AuthGuard>
              <Layout />
            </AuthGuard>
          }
        >
          {LEGACY_FEATURES_ENABLED ? (
            <>
              {/* Legacy: chat, part studio edits, drawing tools (unwired in production) */}
              <Route path="/" element={<Chat />} />
              <Route path="/chats" element={<Chats />} />
              <Route path="/chats/:chatId" element={<ChatPage />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/hardware" element={<HardwareHome />} />
              {!isIframe && <Route path="/dashboard" element={<Dashboard />} />}
            </>
          ) : (
            <Route path="/" element={<HardwareHome />} />
          )}
          <Route path="/settings" element={<Settings />} />
        </Route>

        {/* Catch all - redirect to root */}
        <Route path="*" element={<RedirectHome />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
